/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { PersonalAccessTokenId } from "./PersonalAccessTokenId";
export const PersonalAccessToken = core.serialization.object({
    id: PersonalAccessTokenId,
    name: core.serialization.string(),
    createdAt: core.serialization.date(),
    lastUsedAt: core.serialization.date().optional(),
});
